import Vue from 'vue'
import router from './router'
import cookie from '@/assets/js/cookie.js'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import '@/assets/css/icon-wulianwang/iconfont.css'
import setTitle from '@/assets/js/setTitle.js' // 设置页面标题
import echarts from 'echarts'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import '@/assets/css/global.css'
import App from './App'
import store from './tool/store'
import { Modal,Message } from 'iview'
import 'babel-polyfill'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import VueVideoPlayer from 'vue-video-player'
import lib from '@/assets/js/lib/index'


/*
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // config.headers['Token'] = 'e88dd8f4-86a0-46ba-8061-9e30eed3a6f4'
    config.headers['Token'] = 'd07c55eb-3a6a-427f-a409-d69e76cdf3de'
    config.headers['UserName'] = 'admin'
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
*/

window.setTitle = setTitle //挂在window的上面。全局可直接使用
window.cookie = cookie
window.lib = lib
if(!store.state.loginpath) store.dispatch('LoginPath', '/login')

axios.interceptors.request.use(
  config => {
    //判断是否存在token，如果存在的话，则每个http header都加上token
    if (store.state.token) {
      config.headers['Content-Type'] = "application/json; charset=utf-8"
      config.headers['token'] = store.state.token
      config.headers['username'] = store.state.username
    }else{
      if(navigator.userAgent.toLowerCase().indexOf('miniprogram') != -1) {
        wx.miniProgram.navigateTo({url: '../index/index'})
      }else{
        router.replace({ //跳转到登录页面
          path: store.state.loginpath,
          query: { redirect: router.currentRoute.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    }
    return config
  }
);
//respone拦截器
axios.interceptors.response.use(
  response => {
    if(response.data.StatusCode == 200) {
      return response
    }else if(response.data.StatusCode == 403){
      if(response.data.Error == "Token已过期或无效"){
        sessionStorage.setItem("token",'')
        sessionStorage.setItem("username",'')
        var isMp = (navigator.userAgent.toLowerCase().indexOf('miniprogram') != -1)
        var content = isMp ? "您的账号已在别处登录，确认为您重新登录？" : "您的账号已在别处登录，请重新登录！"
        Modal.confirm({
          // title: '',
          content: content,
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            if(isMp) {
              wx.miniProgram.navigateTo({url: '../index/index'})
            }else{
              router.replace({ //跳转到登录页面
                path: store.state.loginpath,
                //query: { redirect: router.currentRoute.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
              })
            }
          },
          onCancel: () => {
            // router.replace({ //跳转到登录页面
            //   path: '/login',
            //   //query: { redirect: router.currentRoute.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            // })
          }
        })
      }else{
        throw new Error(response.data.Error)
      }
    }else if(lib.is_string(response.data)){
      return response
    }else{
      if(lib.isArray(response.data)) {//过滤掉本地城市JSON数据的报错
        return response
      }else{
        console.log('lanjienihendiao')
        throw new Error(response.data.Error)
      }
    }
  },
  error => { //默认除了2XX之外的都是错误的，就会走这里
    if (error.response) {
      switch (error.response.StatusCode) {
        case 401:
          console.log(401)
          if(navigator.userAgent.toLowerCase().indexOf('miniprogram') != -1) {
            wx.miniProgram.navigateTo({url: '../index/index'})
          }else{
            router.replace({ //跳转到登录页面
              path: store.state.loginpath,
              // query: { redirect: router.currentRoute.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            });
          }
      }
    }
    return Promise.reject(error.response)
  }
);

Vue.use(VueAxios, axios)
Vue.prototype.$echarts = echarts
Vue.use(iView)
Vue.use(Mint)
Vue.config.productionTip = false
Vue.use(VueVideoPlayer)
// 路由跳转
Vue.prototype.$goRoute = function (index) {
  this.$router.push(index)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js